import { h } from 'preact';

const Button = (props) => {
	const { color, copy, onClick, state } = props;
	return (
		<div onClick={onClick} className={`c-Button ${color} ${state === 'loading' ? 'is-loading' : ''}`}>
			{state !== 'loading' ? copy : ''}
			{state === 'loading' &&
			<div class="spinner">
				<div class="bounce1"></div>
				<div class="bounce2"></div>
				<div class="bounce3"></div>
			</div>
			}
		</div>
	); 
};

export default Button;


// WEBPACK FOOTER //
// ./components/Button.js